import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { ModalContent } from "@amzn/stencil-react-components/modal";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React from "react";

const STRING_PATH = "checkout.formPanel.cancelModal";

export interface CancelOrderModalProps {
  close: () => void;
  onConfirm: (close: () => void) => void;
}

export const CancelOrderModal: React.FC<CancelOrderModalProps> = ({ close, onConfirm }) => (
  <ModalContent
    data-testid="cancel-order-modal"
    titleText={getString(`${STRING_PATH}.title`)}
    buttons={[
      <Button key="no-modal-button" onClick={close}>
        {getString(`${STRING_PATH}.noButton`)}
      </Button>,
      <Button key="yes-modal-button" variant={ButtonVariant.Primary} onClick={() => onConfirm(close)}>
        {getString(`${STRING_PATH}.yesButton`)}
      </Button>,
    ]}
  >
    <Text fontSize="T200" color="neutral90">
      {getString(`${STRING_PATH}.content`)}
    </Text>
  </ModalContent>
);
